<template>
  <div class="article-edit">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/article-list' }">文章管理</el-breadcrumb-item>
      <el-breadcrumb-item>文章编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content-1">
      <label>标题：</label>
      <el-input
        placeholder="请输入内容"
        v-model="title"
        type="textarea"
        autosize>
      </el-input>
    </div>
    <div class="content-1">
      <label>分类：</label>
      <el-select v-model="article_variety_id" placeholder="请选择">
        <el-option
          v-for="item in variety_list"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="content-2">
      <div class="left">
        <div class="main_body">
          <vue-ueditor-wrap  :config="ueConfig" v-model="content" @ready="ready"></vue-ueditor-wrap>
        </div>
        <el-button type="primary"  @click="submitArticle">提交</el-button>
      </div>
      <div class="right">
        <div class="text-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        variety_list:[],
        article_id:'',
        title:'',
        article_variety_id:'',
        content:'',
        temp:'',
        ueConfig:{
          UEDITOR_HOME_URL : process.env.NODE_ENV === 'production' ? '/static/UEditor/':'/static/UEditor/',
          serverUrl: this.G.baseUrl + "/v1/admin/rich-text", // 上传文件接口
          // serverUrl: "https://www.moyinshucang.cn/v1/rich-text", // 上传文件接口

          'fontfamily':[
            { label:'',name:'songti',val:'宋体,SimSun'},
            { label:'仿宋',name:'fangsong',val:'仿宋,FangSong'},
            { label:'仿宋_GB2312',name:'fangsong',val:'仿宋_GB2312,FangSong'},
            { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
            { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
            { label:'',name:'heiti',val:'黑体, SimHei'},
            { label:'',name:'lishu',val:'隶书, SimLi'},
            { label:'',name:'andaleMono',val:'andale mono'},
            { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
            { label:'',name:'arialBlack',val:'arial black,avant garde'},
            { label:'',name:'comicSansMs',val:'comic sans ms'},
            { label:'',name:'impact',val:'impact,chicago'},
            { label:'',name:'timesNewRoman',val:'times new roman'}
          ],
          // 初始容器高度
          initialFrameHeight:610,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 编辑器不自动被内容撑高 false
          autoHeightEnabled: false,
          elementPathEnable: false,
          wordCount: false,
        },
      }
    },
    methods:{
      ready(editor){
        let _this = this;
        setTimeout(function(){
          editor.setContent(_this.temp);
          _this.content = _this.temp;
        },500)
      },
      getInfo(){
        this.$get('/v1/admin/article-info?id=' + this.$route.query.id, {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.article_id = res.data.data.data.id;
              this.title = res.data.data.data.title;
              this.article_variety_id = res.data.data.data.label_id;
              this.temp = res.data.data.data.content;
              this.title = res.data.data.data.title;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      getVariety(){
        this.$get('/v1/admin/label?&pages=1&limit=1000', {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.variety_list = res.data.data.data;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      submitArticle(){
        if(!this.title){
          this.$msg('请填写标题！');
          return false;
        }
        if(!this.article_variety_id){
          this.$msg('请选择分类！');
          return false;
        }
        if(!this.content){
          this.$msg('请填写正文！');
          return false;
        }

        let data ={
          id:this.article_id,
          title:this.title,
          label_id:this.article_variety_id,
          content:this.content
        };
        this.$put('/v1/admin/article', data)
          .then((res) => {
            if (res.data.status === 'success') {
              this.goOff()
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      goOff(){
        this.$router.go(-1);
      },
      goTo(path,id){
        this.$router.push({
          path:path,
          query:{
            id:id
          }
        })
      }
    },
    created() {
      this.getInfo();
      this.getVariety();
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .article-edit
    width:100%;
    height:100%;
    padding:0 20px;
    background-color:#fff;
    border-radius: 18px;
    box-shadow: 0 8px 4px -4px rgba(216,216,216,0.5);
    overflow auto
    .content-1
      display flex
      align-items center
      width:100%;
      padding 0 94px
      margin 20px 0 30px
      font-size 16px
      label
        display inline-block
        width 60px
    .content-2
      position relative
      width:100%;
      height: 812px;
      margin-top:20px;
      .left
        position absolute
        width 475px;
        height: 812px;
        top 0
        left 0
        padding-left 94px
        >span
          position absolute
          left 30px
          display inline-block
          min-width:64px;
          line-height:40px;
          font-size:14px;
          color:#333;
          text-align right
        .main_body
          top 0
          left 94px
          right 56px
          height: auto;
          background: #F9F9F9;
          box-shadow: 1px 1px 4px 0px rgba(187,187,187,0.5);
          border-radius: 8px;
          >div
            height:100%;
            .edui-default .edui-editor
              border none
        button
          width: 120px;
          height: 45px;
          margin 22px 120px
          font-size:14px;
      .right
        position absolute
        width 445px
        height 812px
        top 0
        left 510px
        background-image url('./img/phone.jpg')
        background-position center
        background-repeat no-repeat
        background-size 445px 820px
        .text-content
          position absolute
          width 375px
          height 680px
          top 70px;
          left 40px;
          padding 0 6px
          overflow-y scroll
          background #fff



</style>



// WEBPACK FOOTER //
// src/pages/ArticleManage/ArticleEdit.vue